import { call, put, takeEvery } from 'redux-saga/effects';
import { getCountryListService } from '../../services/countryList';
import * as type from '../ActionTypes';
import { filterCountryList } from '../../constants/address';
import { getStates } from '../../services/register';
import { successStatusCodeList } from '../../helper/utils';

function* getCountryList(): any {
  try {
    const countryListData = yield call(getCountryListService);
    const filterCountry = yield countryListData?.data.filter((country: any) =>
      filterCountryList.includes(country.code)
    );
    yield put({
      type: type.GET_COUNTRY_LIST_SUCCESS,
      data: filterCountry
    });
  } catch (e: any) {
    yield put({ type: type.GET_COUNTRY_LIST_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* getStateList(action: any): any {
  try {
    const stateList = yield call(getStates, action.payload);
    if (successStatusCodeList.includes(stateList?.status)) {
      yield put({
        type: type.GET_STATE_SUCCESS,
        data: stateList?.data
      });
    } else {
      yield put({ type: type.GET_STATE_ERROR, message: 'Oops! Something went wrong' });
    }
  } catch (e: any) {
    yield put({ type: type.GET_STATE_ERROR, message: e.message });
    console.warn(e.message);
  }
}

function* countryListSaga() {
  yield takeEvery(type.GET_COUNTRY_LIST, getCountryList);
  yield takeEvery(type.GET_STATE_REQUEST, getStateList);
}

export default countryListSaga;
